
import { defineComponent } from 'vue'
import { useSession } from '@/composables/auth'

export default defineComponent({
  setup() {
    let { loggedIn, ensureLoggedOrRedirect } = useSession()
    return { ensureLoggedOrRedirect, loggedIn }
  },
  methods: {
    ssoLogin() {
      let redirect = '/home'
      if (this.$route.params.redirectTo) redirect = this.$route.params.redirectTo as string
      if (redirect) {
        this.ensureLoggedOrRedirect(redirect)
      }
    }
  },
  created(){
    if(this.loggedIn)
    {
      this.$router.push('/home')
    }
  }
})
